import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { createPortal } from 'react-dom';
import ImageComponent from '../../../common/Image';
import { useDispatch, useSelector } from "react-redux";
import { checkIfscCode, checkmandateStatus, etbCheck, getBankIfsc, hyperverge, hypervergecheck, mandateCheck, sendMandateLink, setStage, setSubStage } from '../../../../slices/eligibility/eligibilitySlice';
import { toast } from 'react-toastify';
import Loader from '../../../common/Loader';
import Lightbox from "./Lightbox";
import { useNavigate } from 'react-router-dom';

function BankDetails() {

    const href = "#";
    const dispatch = useDispatch()

    const Ref = useRef(null);
    const { bank_details: custBankDetails } = useSelector(state => state.eligibility?.allDetails?.response_data)
    const { hyper_verge_qr } = useSelector(state => state.eligibility?.allDetails?.response_data) ?? true
    console.log(custBankDetails)

    const bankAccountRef = useRef(null);
    const { referenceId } = useSelector(state => state.dashboard);

    const [loader, setLoader] = useState(false)
    const [mandate, setMandate] = useState(false)
    const [timer, setTimer] = useState("00:00:00");
    const [showPopup, setShowPopup] = useState(false)
    const [isFocused, setIsFocused] = useState(false);
    const [upiId, setUpiId] = useState('')
    const [upiQrUrl, setUpiQrUrl] = useState('')
    const [bankDetails, setBankdetails] = useState()
    const [readOnly, setReadOnly] = useState(false)
    const [searchPopup, setSearchPopup] = useState(false)
    const [overlay, setOverlay] = useState(false)
    const [branch, setBranch] = useState([])
    const [hideBtn, setHideBtn] = useState(false)
    const [rejectionPopup, setRejectionPopup] = useState('')
    const [qrCode, setQrCode] = useState('')
    const [mobileNo, setMobileNo] = useState('')
    const [mandateUrl, setMandateUrl] = useState()
    const [upiCount, setupiCount] = useState(0)
    const [bankBranchReadOnly, setBankBranchReadOnly] = useState(false)

    const [mandateType, setMandateType] = useState((custBankDetails !== undefined || hyper_verge_qr === false) ? 'manual' : '')

    console.log(custBankDetails, hyper_verge_qr, mandateType, "testttt")
    const [maxCount, setMaxCount] = useState()
    const [status, setStatus] = useState(null);

    const navigate = useNavigate()

    const qrTimerRef = useRef(null);
    const qrExpiryRef = useRef(null);

    const [qrTimer, setQrTimer] = useState("05:00");

    // 🧠 Step 1: Setup Formik in JS
    const formik = useFormik({
        initialValues: {
            // Radio selection: which mandate flow the customer wants.
            // Required — customer must pick one before proceeding.
            mandate_type: custBankDetails?.mandate_type ?? '',

            bank_ifsc_code: custBankDetails?.bank_ifsc_code ?? '',
            bank_name: custBankDetails?.bank_name ?? '',
            branch_name: custBankDetails?.branch_name ?? '',
            bank_account_number: custBankDetails?.bank_account_number ?? '',
            re_bank_account_number: custBankDetails?.bank_account_number ?? '',
            mandate_status: "initiate"
        },
        validationSchema: Yup.object({
            mandate_type: Yup.string()
                .oneOf(['e-mandate', 'upi-mandate'], 'Please select a valid mandate type')
                .required('Please select a mandate type to proceed'),

            bank_ifsc_code: Yup.string().required('IFSC Code is required').matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Enter a valid Bank IFSC Code code'),
            bank_name: Yup.string().required('Bank Name is required'),
            branch_name: Yup.string().required('Branch Name is required'),
            bank_account_number: Yup.string().required('Account Number is required'),
            re_bank_account_number: Yup.string()
                .required('Please re-enter your account number')
                .oneOf([Yup.ref('bank_account_number'), null], 'Account numbers must match'),
        }),
        validateOnMount: false,
        validateOnBlur: true,
        validateOnChange: false,
        onSubmit: async (values) => {
            // Add your API call or logic here
            setLoader(true)
            const response = await dispatch(sendMandateLink({ ...values, reference_id: referenceId }))
            setLoader(false)

            if (response?.payload?.response_code === 'S100') {
                setMandate("initiated")
                setMandateUrl(response?.payload?.response_data?.murl)
                setMobileNo(response?.payload?.response_data?.mobile_number)
                setQrCode(response?.payload?.response_data?.qr_url)
                setOverlay(true);
                setTimer("01:00");
                clearTimer(getDeadTime());
            }
            else if (response?.payload?.response_code === 'E135') {
                setRejectionPopup(response?.payload?.response_string)
            }
            else {
                !response?.payload?.error &&
                    toast.error(response?.payload?.response_string || "Something went wrong", {
                        position: 'top-right',
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined
                    });
            }
        },
    });

    console.log(formik?.errors, formik?.touched)

    const fetchBankDetails = useCallback(async () => {
        if (referenceId) {
            setLoader(true)
            try {
                let response = await dispatch(etbCheck({
                    "reference_id": referenceId,
                })).unwrap();
                setLoader(false)
                if (response?.response_code === 'E196') {
                    setBankdetails(response?.response_data)
                    setLoader(false)
                }
                else if (response?.response_code === 'S100') {
                } else {
                    setLoader(false)
                    !response?.payload?.error &&
                        toast.error(response?.data?.response_string);
                }
            } catch (error) {
                setLoader(false)
                toast.error('An error occurred while fetching product data');
            }
        }
    }, [referenceId, dispatch]);

    useEffect(() => {
        React.memo(fetchBankDetails());
    }, [fetchBankDetails]);

    const handleBankNameChange = async (e) => {
        const value = e.target.value
        formik.setFieldValue("search_bank_name", value);
    }

    const handlebank_ifsc_codeUppercaseChange = async (e) => {
        const value = e.target.value.toUpperCase();

        // Matches partial bank_ifsc_code format while typing:
        // 4 uppercase letters → 1 zero → 6 alphanumeric
        const regex = /^[A-Z]{0,4}$|^[A-Z]{4}0$|^[A-Z]{4}0[A-Z0-9]{0,6}$/;

        const upperValue = value.toUpperCase();

        // ❌ Block "IPOS" IFSC (invalid code)
        if (upperValue.startsWith("IPOS")) {
            toast.error("IPOS Bank not allowed")
            return; // prevent setting the value
        }

        if (value === "" || (regex.test(upperValue) && upperValue.length <= 11)) {
            formik.setFieldValue("bank_ifsc_code", upperValue);

            // Full valid IFSC → 4 letters + 0 + 6 alphanumeric
            if ((/^[A-Z]{4}0[A-Z0-9]{6}$/).test(upperValue)) {
                setLoader(true);
                const response = await dispatch(checkIfscCode({ "IFSC_Code": upperValue, "reference_id": referenceId }));
                setLoader(false);

                if (response?.payload?.response_code === 'S100') {
                    formik?.setFieldValue("bank_name", response?.payload?.response_data?.Bank_Name);
                    formik?.setFieldValue("branch_name", response?.payload?.response_data?.Branch_Name);
                } else {
                    !response?.payload?.error &&
                        toast.error(response?.payload?.response_string || "Something went wrong", {
                            position: 'top-right',
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined
                        });
                }
            }
        }
    };

    const getTimeRemaining = (e) => {
        const total = Date.parse(e) - Date.parse(new Date());  // Get total remaining time in milliseconds
        const seconds = Math.floor((total / 1000) % 60);  // Remaining seconds
        const minutes = Math.floor((total / 1000 / 60) % 60);  // Remaining minutes
        return { total, minutes, seconds };
    };

    // Function to start the timer and update the state
    const startTimer = (e) => {
        let { total, minutes, seconds } = getTimeRemaining(e);
        if (total >= 0) {
            // Update the timer if time is still remaining
            setTimer(
                (minutes > 9 ? minutes : "0" + minutes) + ":" + (seconds > 9 ? seconds : "0" + seconds)
            );
        } else {
            // If time is over, clear the interval
            clearInterval(Ref.current);
        }
    };

    // Function to clear the previous interval and start a new one
    const clearTimer = (e) => {
        setTimer("01:00");  // Reset timer to 120 seconds (2 minutes)

        // Clear the previous interval (if any)
        if (Ref.current) clearInterval(Ref.current);

        // Set a new interval to update the timer every second
        const id = setInterval(() => {
            startTimer(e);
        }, 1000);
        Ref.current = id;  // Store the interval ID in Ref
    };

    // Function to get the deadline (current time + 120 seconds)
    const getDeadTime = () => {
        let deadline = new Date();
        deadline.setSeconds(deadline.getSeconds() + 60);  // Add 120 seconds (2 minutes)
        return deadline;
    };

    const checkStatus = useCallback(async () => {
        const response = await dispatch(checkmandateStatus({ reference_id: referenceId }))
        if (response?.payload?.response_code === 'S100') {
            if (response?.payload?.response_data?.mandate_status === 'MANDATE_SUCCESS') {
                setOverlay(false)
                setShowPopup(true)
                setMandate("success")
                setTimeout(() => {
                    setShowPopup(false);
                }, 5000);
            }
            else if (response?.payload?.response_data?.mandate_status === 'REINITIATE_MANDATE') {
                setOverlay(false)
                formik?.setFieldValue('mandate_status', response?.payload?.response_data?.mandate_status)
            }
            else if (response?.payload?.response_data?.mandate_status === 'REINITIATE_WITH_ALTERNATE') {
                formik?.resetForm()
                setOverlay(false)
                setMandate('')
                formik?.setFieldValue('mandate_status', response?.payload?.response_data?.mandate_status)
            }
            else {
                toast.error("Please complete the mandate", {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
            }
        }
        else if (response?.payload?.response_code === "E207") {
        } else {
            !response?.payload?.error &&
                toast.error(response?.payload?.response_string || "Something went wrong", {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
        }
    }, [])

    const handleMandateRetrieve = async () => {
        try {
            setOverlay(false);
            setLoader(true);
            const response = await dispatch(checkmandateStatus({ reference_id: referenceId }));
            setLoader(false);

            if (response?.payload?.response_code === 'S100') {
                if (response?.payload?.response_data?.status?.toLowerCase() === 'success') {
                    setMandate("success");
                } else {
                    toast.info('Mandate is still in progress');
                    setOverlay(true);
                }
            } else {
                !response?.payload?.error &&
                    toast.error(response?.payload?.response_string || 'Failed to retrieve mandate status');
                setOverlay(true);
            }
        } catch (error) {
            console.error('Error retrieving mandate status:', error);
            toast.error('Failed to retrieve mandate status');
            setOverlay(true);
            setLoader(false);
        }
    };

    const setValues = async () => {
        formik?.setFieldValue("bank_ifsc_code", bankDetails?.bank_ifsc_code)
        formik?.setFieldValue("bank_name", bankDetails?.bank_name)
        formik?.setFieldValue("branch_name", bankDetails?.branch_name)
        formik?.setFieldValue("bank_account_number", bankDetails?.bank_account_number)
        formik?.setFieldValue("re_bank_account_number", bankDetails?.bank_account_number)
        // Existing-details flow always leads to the manual/e-mandate form,
        // so keep the mandatory radio field in sync.
        formik?.setFieldValue("mandate_type", bankDetails?.mandate_type)
        setMandateType('manual')
        setBankdetails()
    }

    const setNonValues = async () => {
        setLoader(true)
        let response = await dispatch(mandateCheck(
            {
                reference_id: referenceId,
                "confirm": false
            }
        )).unwrap()
        setLoader(false)
        if (response?.response_code === 'S100') {
            setBankdetails()
        }
        else {
            !response?.payload?.error &&
                toast.error(response?.response_string || "Something went wrong", {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
        }
    }

    const getIfscCode = async () => {
        let data = {
            bank_name: formik?.values?.search_bank_name?.replaceAll(" ", "_"),
            branch_name: formik?.values?.search_branch_name?.replaceAll(" ", "_")
        }
        setLoader(true)
        const response = await dispatch(getBankIfsc(data)).unwrap()
        setLoader(false)
        if (response?.response_code === 'S100') {
            setBranch(response?.response_data)
            setHideBtn(true)
        }
        else {
            !response?.payload?.error &&
                toast.error(response?.response_string)
        }
    }

    const setIfscCode = () => {
        formik?.setFieldValue("bank_ifsc_code", formik?.values?.selected_ifsc_branch)
        formik?.setFieldValue("bank_name", formik?.values?.search_bank_name)
        formik?.setFieldValue("branch_name", formik?.values?.search_branch_name)
        setSearchPopup(false)
    }

    const handlePaste = (e) => {
        e.preventDefault(); // Prevents the default paste action
        // Optionally, you can add a message or other logic here
    };

    useEffect(() => {
        let intervalId;
        if (mandate === 'initiated') {
            checkStatus();
            intervalId = setInterval(() => {
                checkStatus();
            }, 60000);
        }
        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [mandate]);

    const showIfscPopup = () => {
        formik?.setFieldValue("search_bank_name", '')
        formik?.setFieldValue("search_branch_name", '')
        formik?.setFieldValue("selected_ifsc_branch", '')
        setSearchPopup(true)
    }

    const openPopup = async () => {
        setLoader(true)
        const response = await dispatch(hyperverge(
            { reference_id: referenceId }
        )).unwrap()
        setLoader(false)
        if (response?.response_data?.qrCode) {
            setMandateType('upi')
            setUpiId(response?.response_data?.verificationId)
            setUpiQrUrl('data:image/png;base64,' + response?.response_data?.qrCode)
            startQrTimer();
            setupiCount((response?.response_data?.max_count - response?.response_data?.current_count))
        }
        else if (response?.response_code === 'E338') {
            setMandateType('manual')
            formik.resetForm({
                values: {
                    // Preserve the mandatory selection when falling back to
                    // manual entry (UPI wasn't available for this customer).
                    mandate_type: '',
                    bank_ifsc_code: '',
                    bank_name: '',
                    branch_name: '',
                    bank_account_number: '',
                    re_bank_account_number: '',
                    mandate_status: "initiate"
                }
            });
        }
        else {
            toast.error(response?.response_string || "Something went wrong", {
                position: 'top-right',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
            });
        }
    }

    useEffect(() => {
        return () => {
            if (qrTimerRef.current) {
                clearInterval(qrTimerRef.current);
                qrTimerRef.current = null;
            }
        };
    }, []);

    useEffect(() => {
        if (mandateType !== "upi" && qrTimerRef.current) {
            clearInterval(qrTimerRef.current);
            qrTimerRef.current = null;
        }
    }, [mandateType]);

    const getRemainingTime = (deadline) => {
        const total = deadline - new Date().getTime();
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const seconds = Math.floor((total / 1000) % 60);
        return { total, minutes, seconds };
    };

    const startQrTimer = () => {
        // ⏱ 10 minutes from now
        qrExpiryRef.current = new Date().getTime() + 5 * 60 * 1000;
        setQrTimer("05:00");
        if (qrTimerRef.current) {
            clearInterval(qrTimerRef.current);
        }
        qrTimerRef.current = setInterval(() => {
            const { total, minutes, seconds } = getRemainingTime(qrExpiryRef.current);
            if (total <= 0) {
                clearInterval(qrTimerRef.current);
                qrTimerRef.current = null;
                // 🔁 QR expired → regenerate
                regenerateQr();
            } else {
                setQrTimer(
                    `${minutes.toString().padStart(2, "0")}:${seconds
                        .toString()
                        .padStart(2, "0")}`
                );
            }
        }, 1000);
    };

    const regenerateQr = async () => {
        console.log("🔁 QR expired, regenerating...");
        setUpiQrUrl("");
        setUpiId("");
        setStatus(null);
        await openPopup(); // 🔥 existing API call
        startQrTimer();    // 🔄 restart 10 min timer
    };

    const checkUpiStatus = async () => {
        const response = await dispatch(hypervergecheck(
            { reference_id: referenceId, verificationId: upiId }
        ))?.unwrap()

        if (response?.response_code?.toLowerCase() === "s100") {
            setStatus('success')
            if (response?.response_data?.bank_name || response?.response_data?.branch_name) {
                setBankBranchReadOnly(true);
            }
            setReadOnly(true)

            const data = response.response_data;

            formik.setValues(
                {
                    ...formik.values,
                    bank_ifsc_code: data.ifsc,
                    bank_name: data.bank_name,
                    branch_name: data.branch_name,
                    bank_account_number: data.bankAccount,
                    re_bank_account_number: data.bankAccount,
                },
                true // ✅ triggers validation
            );

            // ✅ clear touched so errors disappear immediately
            formik.setTouched({
                bank_ifsc_code: false,
                bank_name: false,
                branch_name: false,
                bank_account_number: false,
                re_bank_account_number: false,
            });

            setMandateType("manual")
        }
        else if ((response?.response_code?.toLowerCase() === "e337" || response?.response_code?.toLowerCase() === "e209")) {
            !response?.payload?.error &&
                toast.error(response?.response_string || "Something went wrong", {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
            regenerateQr();
        }
        else if (response?.response_code?.toLowerCase() === "e335") {
        }
        else if (response?.response_code?.toLowerCase() === 'e135') {
            !response?.payload?.error &&
                toast.error(response?.response_string || "Something went wrong", {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
            navigate('/dashboard')
        }
        else {
            !response?.payload?.error &&
                toast.error(response?.response_string || "Something went wrong", {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
        }
    }

    useEffect(() => {
        if (mandateType !== "upi" || !upiQrUrl) return;
        const interval = setInterval(() => {
            checkUpiStatus();
        }, 10000);
        return () => clearInterval(interval);
    }, [mandateType, upiQrUrl]);

    // 🔹 Stop polling automatically
    useEffect(() => {
        if (status === "SUCCESS" || status === "FAILED") {
            // interval clears automatically due to dependency change
            console.log("Polling stopped:", status);
        }
    }, [status]);

    useEffect(() => {
        if (formik.values.search_bank_name || formik.values.search_branch_name) {
            setHideBtn(false);
        }
    }, [formik.values.search_bank_name, formik.values.search_branch_name]);

    console.log(mandate, bankBranchReadOnly, custBankDetails?.bank_name, hyper_verge_qr === true)

    return (
        <>
            {overlay === true && createPortal(<Lightbox stage="mandate" onRetrieve={handleMandateRetrieve} mandateUrl={mandateUrl} qrCode={qrCode} mobileNumber={mobileNo} />, document.body)}
            {loader === true && <Loader />}
            {(mandateType && mandateType === 'upi') &&
                <div className="container-fluid kyc-tab-dash-app height-scroll screen-bros-dash">
                    <div className="row gy-3 screenbro">
                        <div className="col-md-12 col-sm-12 text-center">
                            <p className="fw-semibold m-0 text-dark">Please scan the QR using any UPI app</p>
                        </div>
                        <div className="col-12 col-sm-12">
                            <div className="text-center ">
                                <img
                                    src={upiQrUrl}
                                    alt=""
                                    className={"img-fluid"}
                                />
                            </div>
                        </div>
                        <p className="text-danger fw-semibold mt-2 d-flex justify-content-center">
                            You have remaining {upiCount} attempts
                        </p>
                        <p className="text-danger fw-semibold mt-2 d-flex justify-content-center">
                            QR expires in {qrTimer}
                        </p>
                    </div>
                </div>}

            {(!mandateType || mandateType === 'manual') && <form onSubmit={formik?.handleSubmit} autoComplete="off">
                <div className="col-md-9 col-sm-12 Side-bank-Right">
                    <div className="row static-tab">
                        <div className="col-12 floating-bottom">
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="Pname-i">Account Details</p>
                            </div>
                        </div>

                        {!mandateType && <div className="justify-content-center mb-3 gap-3">
                            <div className="col-12 mt-3 mb-4">
                                <button className="btn btn-primary qr-btn" onClick={() => { openPopup() }}>
                                    Fetch Details through UPI QR Code <br /> (Recommended)
                                </button>
                            </div>
                            <div className='col-12'>
                                <button className="btn btn-outline-primary qr-btn" onClick={() => { setMandateType('manual') }}>
                                    Enter Details Manually
                                </button>
                            </div>
                        </div>}

                        {/* bank_ifsc_code Code */}
                        {mandateType === 'manual' &&
                            <>
                                <div className="col-12 floating-bottom">
                                    <div className="input-container has-icon">
                                        <input
                                            className="form-control input-underline"
                                            id="bank_ifsc_code"
                                            name="bank_ifsc_code"
                                            type="text"
                                            value={formik.values.bank_ifsc_code}
                                            onChange={handlebank_ifsc_codeUppercaseChange}
                                            placeholder=" "
                                            maxLength={11}
                                            readOnly={mandate || readOnly || (custBankDetails && hyper_verge_qr === true)}
                                            autoComplete='off'
                                            required
                                        />
                                        <label className="label form-label" htmlFor="bank_ifsc_code">
                                            IFSC
                                        </label>
                                        <div className='underline'></div>
                                        {!mandate || !readOnly || (custBankDetails !== undefined && hyper_verge_qr === false) && <div className="has-i-search hidden-search-box eligibility-search" onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault()
                                            }
                                        }}
                                            onClick={() => {
                                                showIfscPopup()
                                            }}>
                                            <span className="icon-searchnormal fs-4 inside-search"></span>
                                        </div>}
                                        {formik.touched.bank_ifsc_code && formik.errors.bank_ifsc_code && (
                                            <div className="text-danger small">{formik.errors.bank_ifsc_code}</div>
                                        )}
                                    </div>
                                </div>

                                {/* Bank Name */}
                                <div className="col-12 floating-bottom">
                                    <div className="input-container has-icon">
                                        <input
                                            className="form-control input-underline"
                                            id="bank_name"
                                            name="bank_name"
                                            type="text"
                                            placeholder=" "
                                            autoComplete='off'
                                            {...formik.getFieldProps('bank_name')}
                                            readOnly={mandate || bankBranchReadOnly || (custBankDetails?.bank_name && hyper_verge_qr === true)}
                                            required
                                        />
                                        <label className="label form-label" htmlFor="bank_name">
                                            Bank Name
                                        </label>
                                        <div className='underline'></div>
                                        {formik.touched.bank_name && formik.errors.bank_name && (
                                            <div className="text-danger small">{formik.errors.bank_name}</div>
                                        )}
                                    </div>
                                </div>

                                {/* Branch Name */}
                                <div className="col-12 floating-bottom">
                                    <div className="input-container has-icon">
                                        <input
                                            className="form-control input-underline"
                                            id="branch_name"
                                            name="branch_name"
                                            type="text"
                                            autoComplete='off'
                                            placeholder=" "
                                            {...formik.getFieldProps('branch_name')}
                                            readOnly={mandate || bankBranchReadOnly || (custBankDetails?.branch_name && hyper_verge_qr === true)}
                                            required
                                        />
                                        <label className="label form-label" htmlFor="branch_name">
                                            Branch Name
                                        </label>
                                        <div className='underline'></div>
                                        {formik.touched.branch_name && formik.errors.branch_name && (
                                            <div className="text-danger small">{formik.errors.branch_name}</div>
                                        )}
                                    </div>
                                </div>

                                {/* Account Number */}
                                <div className="col-12 floating-bottom">
                                    <div className="input-container has-icon">
                                        <input
                                            className="form-control input-underline"
                                            ref={bankAccountRef}
                                            id="bank_account_number"
                                            name="bank_account_number"
                                            autoComplete="new-password"
                                            type="password"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            placeholder=" "
                                            onPaste={(e) => e.preventDefault()}       // block paste
                                            onCopy={(e) => e.preventDefault()}        // block copy
                                            onCut={(e) => e.preventDefault()}         // block cut
                                            onContextMenu={(e) => e.preventDefault()} // block right-click menu
                                            {...formik.getFieldProps("bank_account_number")}
                                            readOnly={mandate || readOnly || (custBankDetails && hyper_verge_qr === true)}
                                            onFocus={() => setIsFocused(true)}
                                            onBlur={(e) => {
                                                formik.handleBlur(e);

                                                // Check match here as well
                                                const acc = formik.values.bank_account_number;
                                                const reAcc = formik.values.re_bank_account_number;
                                                if (acc && reAcc && acc !== reAcc) {
                                                    toast.error("Account numbers doesn't match");
                                                    formik.setFieldValue("bank_account_number", "");
                                                    formik.setFieldValue("re_bank_account_number", "");
                                                    formik.setFieldError("bank_account_number", "Account numbers do not match");
                                                }
                                            }}
                                        />
                                        <label className="label form-label" htmlFor="bank_account_number">
                                            Account Number
                                        </label>
                                        <div className="underline"></div>
                                        {formik.touched.bank_account_number && formik.errors.bank_account_number && (
                                            <div className="text-danger small">{formik.errors.bank_account_number}</div>
                                        )}
                                    </div>
                                </div>

                                {/* Re-enter Account Number */}
                                <div className="col-12 floating-bottom">
                                    <div className="input-container has-icon">
                                        <input
                                            className="form-control input-underline"
                                            id="re_bank_account_number"
                                            name="re_bank_account_number"
                                            autoComplete="new-password"
                                            type="tel"
                                            placeholder=" "
                                            onPaste={(e) => e.preventDefault()}       // block paste
                                            onCopy={(e) => e.preventDefault()}        // block copy
                                            onCut={(e) => e.preventDefault()}         // block cut
                                            onContextMenu={(e) => e.preventDefault()} // block right-click menu
                                            {...formik.getFieldProps("re_bank_account_number")}
                                            readOnly={mandate || readOnly || (custBankDetails && hyper_verge_qr === true)}
                                            required
                                            onBlur={(e) => {
                                                formik.handleBlur(e);

                                                // Check match here as well
                                                const acc = formik.values.bank_account_number;
                                                const reAcc = formik.values.re_bank_account_number;
                                                if (acc && reAcc && acc !== reAcc) {
                                                    toast.error("Account numbers do not match");
                                                    formik.setFieldValue("bank_account_number", "");
                                                    formik.setFieldValue("re_bank_account_number", "");
                                                    formik.setFieldError("re_bank_account_number", "Account numbers do not match");
                                                    bankAccountRef.current?.focus();
                                                }
                                            }}
                                        />
                                        <label className="label form-label" htmlFor="re_bank_account_number">
                                            Re-enter Account Number
                                        </label>
                                        <div className="underline"></div>
                                        {formik.touched.re_bank_account_number && formik.errors.re_bank_account_number && (
                                            <div className="text-danger small">{formik.errors.re_bank_account_number}</div>
                                        )}
                                    </div>
                                </div>
                                <div className="row floating-bottom">
                                    <div className="col-12 d-flex flex-column">
                                        <label className="form-label mb-1 gender-label" htmlFor="mandate">Mandate Type<span className="text-danger"> *</span></label>
                                        <div className="d-flex gap-2 genderbg-btn">
                                            <input
                                                type="radio"
                                                className="btn-check"
                                                id="mandate_type_emandate"
                                                name="mandate_type"
                                                value="e-mandate"
                                                checked={formik.values.mandate_type === 'e-mandate'}
                                                onChange={formik.handleChange}
                                            />
                                            <label className="btn btn-outline-primary custom-gender-btn flex-fill width-50 fw-500" htmlFor="mandate_type_emandate">E-Mandate</label>

                                            <input
                                                type="radio"
                                                className="btn-check"
                                                id="mandate_type_upi"
                                                name="mandate_type"
                                                value="upi-mandate"
                                                checked={formik.values.mandate_type === 'upi-mandate'}
                                                onChange={formik.handleChange}
                                            />
                                            <label className="btn btn-outline-primary custom-gender-btn flex-fill fw-500 width-50" htmlFor="mandate_type_upi">UPI Mandate</label>
                                        </div>
                                        {/* Error display */}
                                        {formik.errors.gender && formik.touched.gender && (
                                            <div className="text-danger" style={{ width: "105px" }}>{formik.errors.gender}</div>
                                        )}
                                    </div>
                                </div>

                                {/* Buttons */}
                                <div className="col-12">
                                    {!mandate && <button className="btn btn-primary w-100 small continue-btn" type="submit">
                                        Initiate Mandate
                                    </button>}
                                    {mandate === 'success' && <button className="btn emandate-success fs-6" type="button">
                                        Mandate <ImageComponent fileName="banktick.svg" alt="tick" />
                                    </button>}
                                </div>

                                {/* Mandate Info */}

                                {mandate === 'initiated' &&
                                    <div className="col-12">
                                        <p className="small m-0 mt-3 label-fridge">Please wait while mandate registration is completed by customer using the mandate link shared .</p>
                                        {timer !== "00:00" && <p className="small m-0 mt-2 label-fridge">Re-initiate mandate in {timer}</p>}
                                        <p className="small">
                                            {timer === "00:00" && <a href={href} className="fw-semibold label-fridge" onClick={formik?.handleSubmit}>
                                                Re-initiate Mandate
                                            </a>}
                                        </p>
                                    </div>}

                                {mandate === 'success' &&
                                    <>
                                        <div className="col-6">
                                            <p className="m-0 small">
                                                <label className="text-secondary fw-medium" htmlFor="mandateStatus">
                                                    Mandate Status
                                                </label>
                                            </p>
                                            <p className="text-success fw-semibold">Completed</p>
                                        </div>

                                        <div className="col-6">
                                            <p className="m-0 small">
                                                <label className="text-secondary fw-medium" htmlFor="mandateType">
                                                    Mandate Type
                                                </label>
                                            </p>
                                            <p className="fw-semibold">Electronic</p>
                                        </div>
                                    </>}
                            </>}
                    </div>
                </div>

                {showPopup &&
                    <>
                        <div className="modal show fade" id="AadharPreview" tabIndex="-1" style={{ display: "block" }} aria-labelledby="panCompLabel" aria-hidden="true" onClick={() => setShowPopup(false)}>
                            <div className="modal-dialog bottom-modal"
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault()
                                        e.stopPropagation()
                                    }
                                }}
                                onClick={(e) => e.stopPropagation()}>
                                <div className="modal-content">
                                    <div className="px-3 py-3 text-center">
                                        <ImageComponent fileName="new-congratulations.gif" className="gif-tick" />
                                        <p className="fw-semibold m-0 mt-3">Mandate Registration</p>
                                        <p className="text-success fw-semibold">Successful</p>
                                        <div className="col-sm-12">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-backdrop fade show"></div>
                    </>}

                {searchPopup &&
                    <>
                        <div className="modal show fade" id="existingcred" tabIndex="-1" style={{ display: "block" }} aria-labelledby="existingcred" aria-hidden="true" onClick={() => setSearchPopup(false)}>
                            <div className="modal-dialog bottom-modal"
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault()
                                        e.stopPropagation()
                                    }
                                }}
                                onClick={(e) => e.stopPropagation()}>
                                <div className="modal-content">
                                    <div className="addon_popup-div">
                                        <div className="row">
                                            <div className="floating-bottom col-lg-12 col-md-12 col-sm-12 mb-3 d-flex justify-content-between align-items-start">
                                                <p className="fw-semibold m-0 mt-3">Search IFSC Code</p>
                                                <button type="button" className="btn-close" onClick={() => { setSearchPopup(false) }} aria-label="Close"></button>
                                            </div>
                                            {/* Bank Name */}
                                            <div className="col-12 floating-bottom">
                                                <div className="input-container has-icon">
                                                    <input
                                                        className="form-control input-underline"
                                                        id="search_bank_name"
                                                        name="search_bank_name"
                                                        type="text"
                                                        placeholder=" "
                                                        autoComplete='off'
                                                        onChange={handleBankNameChange}
                                                        value={formik.values.search_bank_name}
                                                        required
                                                        onKeyDown={(e) => e.stopPropagation()}
                                                    />
                                                    <label className="label form-label" htmlFor="search_bank_name">
                                                        Bank Name
                                                    </label>
                                                    <div className='underline'></div>
                                                    {formik.touched.search_bank_name && formik.errors.search_bank_name && (
                                                        <div className="text-danger small">{formik.errors.search_bank_name}</div>
                                                    )}
                                                </div>
                                            </div>
                                            {/* Branch Name */}
                                            <div className="col-12 floating-bottom">
                                                <div className="input-container has-icon">
                                                    <input
                                                        className="form-control input-underline"
                                                        id="search_branch_name"
                                                        name="search_branch_name"
                                                        type="text"
                                                        autoComplete='off'
                                                        placeholder=" "
                                                        {...formik.getFieldProps('search_branch_name')}
                                                        readOnly={mandate || readOnly}
                                                        required
                                                    />
                                                    <label className="label form-label" htmlFor="search_branch_name">
                                                        Branch Name / City
                                                    </label>
                                                    <div className='underline'></div>
                                                    {formik.touched.search_branch_name && formik.errors.search_branch_name && (
                                                        <div className="text-danger small">{formik.errors.search_branch_name}</div>
                                                    )}
                                                </div>
                                            </div>
                                            {(Array.isArray(branch) && branch?.length > 0 && hideBtn) && (
                                                <div className="col-12 floating-bottom">
                                                    <div className="input-container has-icon">
                                                        <select
                                                            name="selected_ifsc_branch"
                                                            className={`form-control input-underline ${formik.touched.selected_ifsc_branch && formik.errors.selected_ifsc_branch ? 'is-invalid' : ''}`}
                                                            value={formik.values.selected_ifsc_branch}
                                                            onChange={formik?.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        >
                                                            <option value="">Choose Branch...</option>
                                                            {branch?.map((dealer) => (
                                                                <option key={dealer.ifsc} value={dealer.ifsc}>
                                                                    {dealer.branch} - {dealer.branch}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {formik.touched.selected_ifsc_branch && formik.errors.selected_ifsc_branch && (
                                                            <div className="invalid-feedback">{formik.errors.selected_ifsc_branch}</div>
                                                        )}
                                                    </div>
                                                </div>)}
                                        </div>
                                        {(formik?.values?.search_bank_name && formik?.values?.search_branch_name && !hideBtn) && <div className="d-flex justify-content-end">
                                            <button className="btn btn-primary" type="button" onClick={() => { getIfscCode() }}>Search</button>
                                        </div>}
                                        {formik?.values?.selected_ifsc_branch &&
                                            <div className="d-flex justify-content-end">
                                                <button className="btn btn-primary" type="button" onClick={() => { setIfscCode() }}>Proceed</button>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-backdrop fade show"></div>
                    </>
                }

                {bankDetails &&
                    <>
                        <div className="modal show fade" id="existingcred" tabIndex="-1" style={{ display: "block" }} aria-labelledby="existingcred" aria-hidden="true" onClick={() => setBankdetails()}>
                            <div className="modal-dialog bottom-modal"
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault()
                                        e.stopPropagation()
                                    }
                                }}
                                onClick={(e) => e.stopPropagation()}>
                                <div className="modal-content">
                                    <div className="py-3 stepper-title text-center">
                                        <ImageComponent fileName="2fverify.svg" />
                                        <p className="fw-semibold m-0 mt-3">Do you wish to proceed with the exisiting bank details?</p>
                                        <div className="row mt-3 p-3 gy-2">
                                            <div className="exist-pop">
                                                <div className="col-12 col-lg-12 col-md-12">
                                                    <p className=" d-flex justify-content-between">Account Holder Name <span className="dark-blue fw-semibold">{bankDetails?.nanme}</span></p>
                                                </div>
                                                <div className="col-12 col-lg-12 col-md-12">
                                                    <p className=" d-flex justify-content-between">Account Type <span className="dark-blue fw-semibold">{bankDetails?.account_type}</span></p>
                                                </div>
                                                <div className="col-12 col-lg-12 col-md-12">
                                                    <p className=" d-flex justify-content-between">IFSC Code <span className="dark-blue fw-semibold">{bankDetails?.bank_ifsc_code}</span></p>
                                                </div>
                                                <div className="col-12 col-lg-12 col-md-12">
                                                    <p className=" d-flex justify-content-between">Bank Name <span className="dark-blue fw-semibold">{bankDetails?.bank_name}</span></p>
                                                </div>
                                                <div className="col-12 col-lg-12 col-md-12">
                                                    <p className=" d-flex justify-content-between">Branch Name <span className="dark-blue fw-semibold">{bankDetails?.branch_name}</span></p>
                                                </div>
                                                <div className="col-12 col-lg-12 col-md-12">
                                                    <p className=" d-flex justify-content-between">Account Number <span className="dark-blue fw-semibold">{bankDetails?.bank_account_number}</span></p>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="d-flex justify-content-between mt-3">
                                                    <button className="btn btn-outline-primary si" type="button" onClick={() => { setNonValues() }}>No</button>
                                                    <button className="btn btn-primary" type="button" onClick={() => { setValues() }}>Yes</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-backdrop fade show"></div>
                    </>}

                {rejectionPopup &&
                    <>
                        <div className="modal show fade" id="rejectpopup" tabIndex="-1" aria-labelledby="rejectpopup" aria-hidden="true" style={{ display: "block" }}>
                            <div className="modal-dialog bottom-modal">
                                <div className="modal-content">
                                    <div className="px-3 py-3 text-center">
                                        <ImageComponent fileName="rejected.gif" className="gif-cross" />
                                        <p className="mt-3">{rejectionPopup}</p>
                                        <div className="d-flex align-items-center justify-content-center mt-4">
                                            <div>
                                                <a href={href}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        navigate('/dashboard');
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                            e.preventDefault();
                                                            navigate('/dashboard');
                                                        }
                                                    }}>Home</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-backdrop fade show"></div>
                    </>
                }

                {mandate === 'success' && <footer className="sticky-bottom-1">
                    <div className="container-fluid ">
                        <div className="row">
                            <div className="col-sm-12 ">
                                <div className="d-flex justify-content-end">
                                    <button className="btn btn-primary" onClick={() => {
                                        dispatch(setStage("document"));
                                        dispatch(setSubStage("document"));
                                    }} type="button">Proceed</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>}
            </form>}
        </>
    );
}

export default BankDetails;
